import React from 'react';
import { Navigation } from '../components/Navigation';
import { TrialOfferCTA } from '../components/TrialOfferCTA';
import { Footer } from '../components/Footer';
import { ProofHero } from './proof/ProofHero';
import { TestimonialsGrid } from './proof/TestimonialsGrid';
import { ProofCTA } from './proof/ProofCTA';
export function ProofPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-678">
      <Navigation data-id="element-679" />
      <ProofHero data-id="element-680" />
      <TestimonialsGrid data-id="element-681" />
      <ProofCTA data-id="element-682" />
      <TrialOfferCTA data-id="element-683" />
      <Footer data-id="element-684" />
    </div>;
}